import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=e5c77ab4&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=e5c77ab4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c77ab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5c77ab4')) {
      api.createRecord('e5c77ab4', component.options)
    } else {
      api.reload('e5c77ab4', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=e5c77ab4&scoped=true", function () {
      api.rerender('e5c77ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/goods/order/sub/OrderDetail.vue"
export default component.exports